const ROOMS_API_BASE_URL = 'https://batesky-rooms-system.attps.workers.dev'

export interface LogRecordingAttemptParams {
  roomId: string
  roomName: string
  userDid: string
  userHandle: string
  detectionMethod: string
  roomHadRecordingFlair: boolean
}

/**
 * Log a screen recording attempt to the backend
 * This is a fire-and-forget operation that doesn't block the UI
 */
export async function logRecordingAttempt({
  roomId,
  roomName,
  userDid,
  userHandle,
  detectionMethod,
  roomHadRecordingFlair,
}: LogRecordingAttemptParams): Promise<void> {
  try {
    console.log('📝 Logging recording attempt:', {
      roomId,
      roomName,
      userHandle,
      detectionMethod,
    })

    const response = await fetch(`${ROOMS_API_BASE_URL}/recording-attempts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        room_slug: roomId,
        room_name: roomName,
        user_did: userDid,
        user_handle: userHandle,
        detection_method: detectionMethod,
        room_had_recording_flair: roomHadRecordingFlair,
      }),
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      console.error('Failed to log recording attempt:', error)
      // Don't throw - this is fire-and-forget
      return
    }

    console.log('✅ Recording attempt logged successfully')
  } catch (error) {
    // Silently fail - we don't want logging errors to break the user experience
    console.error('Error logging recording attempt:', error)
  }
}
